module.exports = __webpack_public_path__ + "media/img/feature-icon-compose-535c7f6f54161b3d9f2edf444678258f.svg";